import { NAME } from './constants'
import R from 'ramda'
const getState = state => state[NAME]

export const getPeriod = R.compose(state => state.period, getState)
export const getLoading = R.compose(state => state.loading, getState)
export const getSumData = R.compose(state => state.summaryData, getState)
export const getDetailData = R.compose(state => state.detailData, getState)
export const getEFORDContrib = R.compose(state => state.efordContrib, getState)
export const getAgEFORD = R.compose(state => state.agEford, getState)
export const getKpiSpec = R.compose(state => state.kpiSpec, getState)
export const getContribKeys = R.compose(state => state.contribKeys, getState)
export const getCAContribKeys = R.compose(state => state.caContribKeys, getState)
export const getKpiAg = R.compose(state => state.kpiAg, getState)
export const getKpiCAAg = R.compose(state => state.kpiCAAg, getState)
export const getKpiContrib = R.compose(state => state.kpiContrib, getState)
export const getKpiCAContrib = R.compose(state => state.kpiCAContrib, getState)
export const getAggregate = kpi => state => getKpiAg(state)[kpi]
export const getAggregateCA = kpi => state => getKpiCAAg(state)[kpi]
export const getContrib = kpi => state => getKpiContrib(state)[kpi]
export const getCAContrib = kpi => state => getKpiCAContrib(state)[kpi]
export const getGoals = R.compose(state => state.goals, getState)
export const getGoalKpis = R.compose(
  R.uniq,
  R.map(g => g.kpi),
  getGoals
)

export const getMetricRollupMap = R.compose(
  R.fromPairs,
  R.map(({ id, rollup }) => [id, rollup]),
  R.chain(({ metrics }) => metrics),
  getKpiSpec
)

export const getMetricDisplayMap = R.compose(
  R.fromPairs,
  R.map(({ id, display }) => [id, display]),
  R.chain(({ metrics }) => metrics),
  getKpiSpec
)

export const getYear = R.compose(state => state.year, getState)
export const getScatterGraphs = R.compose(state => state.scatterGraphs, getState)
export const getTrendGraphs = R.compose(state => state.trendGraphs, getState)
export const getWeekHourData = R.compose(state => state.weekHourData, getState)
export const getCaData = R.compose(state => state.caData, getState)
export const hasBarData = R.compose(
  state => state.summaryData.length > 0 || state.detailData.length > 0,
  getState
)

export const getShowSelector = R.compose(state => state.showSelector, getState)
export const getGadsSummarizedData = R.compose(state => state.gadsSummarizedData, getState)
export const getGadsMonthlyData = R.compose(state => state.gadsMonthlyData, getState)
export const getPnlWeeklyData = R.compose(state => state.pnlWeeklyData, getState)
export const getMetrics = R.compose(state => state.metrics, getState)
